import { render, staticRenderFns } from "./ChangeLanguageDialog.vue?vue&type=template&id=79bbe0b6"
import script from "./ChangeLanguageDialog.vue?vue&type=script&lang=js"
export * from "./ChangeLanguageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports